/**
 * ケース (workflowId) 自体は取得できたが、需要想定本体の取得が InvalidArgument
 * (前提未充足: ケースに BG が無い、地点 override が不正 等) になった時の専用エラー表示。
 * workflowId が見つからない・形式不正の場合 (AC-WFW-040) は共通の
 * `WorkflowNotFoundView` が担うので、本 component の対象外。
 * core fetch 失敗の中でもこのケースだけは error boundary に投げず、ページ内で
 * 案内する (hooks/useGetDemandForecastDaily の throwOnError override と対)。
 */
import { useTranslation } from 'react-i18next'

import { Flex } from '@enechain/ecloud-designsystem'

import { CompactAlert } from '~/components/common/CompactAlert'

export const InvalidWorkflowIdView = (): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      height="300px"
      paddingX={4}
    >
      <CompactAlert
        description={t('page:demandForecastDaily.error.invalidWorkflowId')}
        // TODO: P-1 PdM文言確定
        status="error"
        title={t('page:demandForecastDaily.error.invalidWorkflowIdTitle')}
      />
    </Flex>
  )
}
